import { useContext, useMemo, useState } from 'react';
import {
  FormControl,
  GridLegacy as Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
} from '@mui/material';

import FilterContext from '../contexts/FilterContext';

const LocationRelationList = ({ currentPage, setCurrentPage, locations, renderChild }) => {
  const { filters } = useContext(FilterContext);
  const [pageSize, setPageSize] = useState(10);

  const filteredLocations = useMemo(
    () => Array.from(locations.filter((equip) => filters.every((f) => f.filter(equip)))),
    [filters, locations]
  );

  const pageCount = useMemo(
    () => Math.ceil(filteredLocations.length / pageSize),
    [filteredLocations, pageSize]
  );

  const paginatedLocations = useMemo(
    () => filteredLocations.slice((currentPage - 1) * pageSize, currentPage * pageSize),
    [filteredLocations, currentPage, pageSize]
  );

  const onPageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(event.target.value);
    setCurrentPage(1);
  };

  return (
    <Grid item container>
      <Grid
        item
        container
        xs={12}
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        sx={{ minHeight: 65 }}
      >
        <InputLabel sx={{ mr: 3 }}>Page Size</InputLabel>
        <FormControl sx={{ minWidth: 120, mr: 3 }} size="small">
          <Select value={pageSize} label="Page Size" onChange={handleChangeRowsPerPage}>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </FormControl>
        <Pagination
          count={pageCount}
          page={currentPage}
          color="info"
          size="small"
          showFirstButton
          showLastButton
          onChange={onPageChange}
        />
      </Grid>
      <Grid item container direction="column" rowSpacing={4} sx={{ ml: 3, mr: 3 }}>
        {paginatedLocations.map((e) => renderChild(e))}
      </Grid>
      <Grid item container xs={12} direction="row" justifyContent="flex-end">
        <Pagination
          count={pageCount}
          page={currentPage}
          color="info"
          size="small"
          showFirstButton
          showLastButton
          sx={{ my: 5 }}
          onChange={onPageChange}
        />
      </Grid>
    </Grid>
  );
};

export default LocationRelationList;
